import axios from 'axios';
 
class NotificationService {  
  putNotificationHide(type, list) {  
    return axios.put(`notification/hide${type}`, 
     list ?  {"notifications": list} : ''
    ); 
  } 
}

export default new NotificationService();